// Daily hours: up to 3 integer digits + up to 2 decimals.
// Accepts half-width (0-9 / ".") and full-width (０-９) digits, plus every decimal
// separator a JP IME can emit: "." (U+002E), "．" (U+FF0E) and "。" (U+3002).
// So it validates raw typed input before normalization as well as the normalized value.
export const DAILY_HOURS_INPUT_REGEX = /^[0-9０-９]{1,3}(?:[.．。][0-9０-９]{0,2})?$/;
